/** 
 * api接口的统一出口
 */
import api from '@/api/api';

// 导出接口
export default {    
    api
}


// WEBPACK FOOTER //
// ./src/api/index.js